import { render, staticRenderFns } from "./Nrs2002Form.vue?vue&type=template&id=13165b1c&scoped=true"
import script from "./Nrs2002Form.vue?vue&type=script&lang=js"
export * from "./Nrs2002Form.vue?vue&type=script&lang=js"
import style0 from "./Nrs2002Form.vue?vue&type=style&index=0&id=13165b1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13165b1c",
  null
  
)

export default component.exports